<template>
    <div class="groups-course">
        <div class="groups-course-select">
            <el-select
                @change="fetchData(1)"
                v-model="form.storeId"
                :placeholder="$t('Common.all_store2')">
                <el-option
                    v-for="item in stores"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id" />
            </el-select>
            <el-select
                @change="fetchData(1)"
                v-model="form.coachId"
                :placeholder="$t('Coach.all_team')">
                <input
                    class="search-input-all"
                    type="text"
                    v-model="searchText"/>
                <el-option
                    v-for="item in filterList"
                    :key="item.id"
                    :label="item.nickname"
                    :disabled="item.id === 'no'"
                    :value="item.id" />
            </el-select>
            <!-- <el-select v-model="form.dimension" placeholder="维度">
                <el-option
                    v-for="item in dimensions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id" />
            </el-select> -->
            <el-date-picker
                @change="fetchData(1)"
                v-model="date"
                :clearable="false"
                type="daterange"
                range-separator="-"
                :start-placeholder="$t('Common.start_time')"
                :end-placeholder="$t('Common.end_time')" />
            <el-button
                type="primary"
                @click="form.dimension = 1;fetchData(1)">
                {{ $t('Stats.Search.staff') }}
            </el-button>
            <el-button
                type="success"
                @click="form.dimension = 2;fetchData(1)">
                {{ $t('Stats.Search.lesson') }}
            </el-button>
            <el-button @click="handleReset()">{{ $t('Common.clear') }}</el-button>
        </div>
        <div class="groups-course-tip">
            {{ $t('Week.refresh_time') }}
        </div>
        <div class="trainer-results-tabel">
            <el-table
                v-if="form.dimension === 1"
                :data="tableData"
                style="width: 100%" border>
                <el-table-column prop="coachNickname" :label="$t('Coach.name_team')">
                    <template slot-scope="{row}">
                        <div
                            @click="handleCoach(row.coachId)"
                            class="fitness-blue cursor-pointer">
                            {{ row.coachNickname }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="lessonCount" :label="$t('Stats.Enter.lesson')" />
                <el-table-column prop="reservedAmt" :label="$t('Stats.Enter.all_appoint')" />
                <el-table-column prop="signedAmt" :label="$t('Stats.Enter.all_sign')" />
            </el-table>
            <el-table
                v-if="form.dimension === 2"
                :data="tableData"
                style="width: 100%" border>
                <el-table-column prop="coachNickname" :label="$t('Coach.name_team')">
                    <template slot-scope="{row}">
                        <div
                            @click="handleCoach(row.coachId)"
                            class="fitness-blue cursor-pointer">
                            {{ row.coachNickname }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="storeName" :label="$t('Lesson.store')" />
                <el-table-column prop="lessonTime" :label="$t('Course.time')" />
                <el-table-column prop="lessonName" :label="$t('Course.name')" />
                <el-table-column prop="reservedAmt" :label="$t('Lesson.appoint_count')" />
                <el-table-column prop="signedAmt" :label="$t('Stats.Enter.sign')" />
            </el-table>
        </div>
        <el-pagination
            v-if="tableData.length"
            class="text-right mt-8"
            @current-change="fetchData"
            :current-page.sync="pagination.page"
            :page-size="pagination.size"
            layout="total, prev, pager, next, jumper"
            :total="pagination.total">
        </el-pagination>
    </div>
</template>
<script>
import { DatePicker, Radio } from 'element-ui';

export default {
    name: 'groups-course',
    components: {
        ElDatePicker: DatePicker,
        ElRadio: Radio
    },
    data() {
        return {
            form: {
                storeId: '',
                coachId: '',
                dimension: 1,
            },
            pagination: {
                size: 20,
                total: 0,
                page: 1,
            },
            date: [],
            tableData: [],
            stores: [],
            coachs: [],
            dimensions: [{
                name: this.$t('Stats.Search.staff'),
                id: 1,
            }, {
                name: this.$t('Stats.Search.lesson'),
                id: 2,
            }],
            searchText: '',
        };
    },
    computed: {
        filterList() {
            if (!this.searchText) return this.coachs;
            const arr = this.coachs.filter(item =>
                item.nickname.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1);
            return arr.length ? arr : [{id: 'no', nickname: this.$t('Common.data_not_found')}];
        },
    },
    created() {
        const today = new Date();
        const begin = today.setTime(today.getTime() - 3600 * 1000 * 24 * 31);
        this.date = [begin, new Date()];
        this.fetchStore();
        this.fetchCoach();
        this.fetchData();
    },
    methods: {
        handleReset() {
            const today = new Date();
            const begin = today.setTime(today.getTime() - 3600 * 1000 * 24 * 31);
            this.date = [begin, new Date()];
            this.form = {
                storeId: '',
                coachId: '',
                dimension: 1,
            };
            this.fetchData(1);
        },
        fetchData(page = null) {
            this.searchText = null;
            if (page) this.pagination.page = page;

            if (this.date.length) {
                this.form.dateFrom = new Date(this.date[0]).format('YYYY-MM-DD');
                this.form.dateTo = new Date(this.date[1]).format('YYYY-MM-DD');
            } else {
                this.form.dateFrom = null;
                this.form.dateTo = null;
            }
            API.get('statistic/team-schedule/pages', {
                params: {...this.form, ...this.pagination},
            }).then(res => {
                this.tableData = res.content;
                this.pagination.total = res.totalElements;
                this.$emit('handleForm', this.form);
            }).finally(() => {
                this.loading = false;
            });
        },
        fetchStore() {
            API.get('store/list').then(res => {
                this.stores = res;
            });
        },
        fetchCoach() {
            API.get('staff/list', {
                params: {
                    option: 'and',
                    roleIds: [9, 10],
                }
            }).then(res => {
                this.coachs = res;
            });
        },
        handleCoach(coachId) {
            this.form.coachId = coachId;
            this.fetchData(1);
        },
    },
};
</script>
<style lang="scss">
.groups-course-select {
    padding: 0 0 15px 0;
    border-bottom: 1px solid #e9e9e9;
    .el-select {
        margin-right: 0.5rem;
    }
    .el-button {
        margin-left: 0.5rem;
    }
}
.groups-course-tip {
    float: right;
    font-size: 12px;
    padding: 15px 0;
}
.task-workers {
    color: #409EFF;
}
</style>
